import AudioChooseWord from '@/services/book/training-states/audio-choose-word';
import AudioPuzzleWord from '@/services/book/training-states/audio-puzzle-word';
import ChooseWord from '@/services/book/training-states/choose-word';

import { ExerciseConverted } from '@/interfaces/class/exercises';
import { Training } from '@/interfaces/class/training';

const allowedTrainings : {
  [key: string]: undefined | Function;
} = {
  AudioChooseWord,
  AudioPuzzleWord,
  ChooseWord,
  WriteWord: undefined,
};

const getState = (exercise: ExerciseConverted) => {
  let updatedData : Training[] = [];

  exercise.dataTraining.forEach((el: Training) => {
    const trainingConverter = allowedTrainings[el.allowedTrainingTypes[0]];
    if (el.visible) {
      if (trainingConverter) {
        updatedData.push(trainingConverter(el, exercise));
      } else {
        updatedData.push(el);
      }
    }
  });

  const results = exercise.data.filter((el: Training) => (el.elementAnswers || []).length).length;

  if (!results) {
    updatedData.map((el: Training) => ({
      ...el,
      allowedTrainingTypes: el.allowedTrainingTypes.unshift('DontKnow'),
    }));
  } else {
    updatedData = updatedData.splice(0, 10);
  }

  return {
    ...exercise,
    dataTraining: updatedData,
    totalSlides: updatedData.length,
  };
};

export default getState;
